import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class NotificationBarComponent extends Component {
  init() {
    this.slug = this.element.getAttribute('data-slug') || 'basic'
    this.buttonClose = this.element.querySelector('.button--close')

    this.buttonClose?.addEventListener('click', () => this.hideAlert())
    window.addEventListener('init-after-load', () => this.showAlert())
  }

  showAlert() {
    if (window.sessionStorage.getItem(`dismissed-notification-${this.slug}`) === 'true') {
      return
    }

    this.element.setAttribute('aria-hidden', 'false')
    this.element.removeAttribute('inert')
  }

  hideAlert() {
    this.buttonClose?.blur()
    this.element.setAttribute('aria-hidden', 'true')
    this.element.setAttribute('inert', 'inert')

    if (this.slug) {
      window.sessionStorage.setItem(`dismissed-notification-${this.slug}`, 'true')
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'notification-bar', NotificationBarComponent))
